import { render, staticRenderFns } from "./PagamentoPagseguro.vue?vue&type=template&id=a292a000&"
import script from "./PagamentoPagseguro.vue?vue&type=script&lang=js&"
export * from "./PagamentoPagseguro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports